<template>
    <v-card class="workspace-dashboard__notifications-card" elevation="0">
        <div class="workspace-dashboard__section-head">
            <div>
                <div class="workspace-dashboard__section-kicker">Notifications</div>
                <h2>Usage and billing signals</h2>
            </div>
        </div>
        <div class="workspace-dashboard__feed-list">
            <article
                v-for="item in notificationItems"
                :key="item.title"
                class="workspace-dashboard__feed-item"
            >
                <span class="workspace-dashboard__feed-dot" :class="`tone-${item.tone}`"></span>
                <div>
                    <strong>{{ item.title }}</strong>
                    <small v-if="item.meta">{{ item.meta }}</small>
                    <p>{{ item.body }}</p>
                </div>
            </article>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'DashboardNotifications',
    props: {
        notificationItems: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
